<template>
  <div :class="`inputDiv ${showErrorMessage ? '-error' : ''}`">
    <div class="externalOverlay" />
    <div class="c-select-container">
      <div
        class="c-select"
        @click="handleClick"
        @focusout="handleFocusOut"
        tabindex="0"
      >
        <div class="content">
          <label class="label">{{ label }}</label>
          <input
            name="k-input"
            :value="value"
            class="not-display"
            type="text"
            autocomplete="nope"
          />
          <div
            v-if="showErrorMessage"
            class="error-message"
          >
            <c-icon
              :class="`icon`"
              color="#EB6365"
              icon="warning"
              size="15px"
            />
            {{ errorMessage }}
          </div>
          <input
            v-else-if="isOpened"
            :aria-label="placeholder"
            v-model="search"
            type="text"
            class="dropdown-button"
            autocomplete="nope"
            name="k-input"
          />
          <input
            v-else
            :aria-label="placeholder"
            :value="value || placeholder"
            type="text"
            class="dropdown-button"
            autocomplete="nope"
            name="k-input"
          />
        </div>
        <c-icon
          :class="`icon ${isOpened ? '-opened' : ''}`"
          color="#323232"
          icon="chevron-down"
          size="16px"
        />
      </div>
      <transition name="slide-down">
        <div
          v-if="isOpened"
          class="options"
        >
          <div
            v-for="option in filteredOptions"
            :key="option"
            class="option"
            :value="option"
            @click="chooseOption(option)"
          >
            {{ option }}
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    options: Array,
    value: String,
    placeholder: {
      type: String,
      default: ''
    },
    errorMessage: String
  },

  data () {
    return {
      isOpened: false,
      showErrorMessage: false,
      search: ''
    }
  },

  computed: {
     filteredOptions() {
      const filtered = this.search
        ? this.options.filter(option => this.normalizedStartsWith(this.search, option))
        : this.options;
      return filtered
    }
  },

  watch: {
    isOpened: {
      handler: function () {
        if (this.isOpened === false) this.search = ''
      }
    }
  },

  methods: {
    handleClick () {
      this.showErrorMessage = false
      if (this.isOpened) this.validate()
      this.isOpened = !this.isOpened
    },
    chooseOption (option) {
      this.isOpened = false
      this.$emit('input', option)
    },
    handleFocusOut () {
      if (this.isOpened) this.isOpened = false
    },
    validate () {
      if (this.value === '') this.showErrorMessage = true
      else this.showErrorMessage = false
    },
    removeDiacritics(text) {
      const normalizedText = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return normalizedText.toLowerCase()
    },
    normalizedStartsWith(search, option) {
      const normalizedSearch = this.removeDiacritics(search)
      const normalizedOption = this.removeDiacritics(option)
      return normalizedOption.startsWith(normalizedSearch)
    }
  }

}
</script>

.<style lang="scss" scoped>
@import '~@style/reference';
.inputDiv{
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: lightgrey 0px 1px 3px 0px;
  margin: 5px;
  width: 458px;
  height: 60px;
  padding: 3px 0px;
  @media screen and (max-width: 850px)  {
      width: unset;
    }
  }

.c-select-container {
  position: relative;
  width: 100%;
  .not-display {
    display: none;
  }
  >.c-select {
    cursor: pointer;

    .error-message {
      justify-content: flex-start;
      display: flex;
      align-items: center;
      font-size: 11px;
      color: red;
      >.icon {
      margin-top: 0px;
      margin-right: 5px;
      fill: red;
    }
    }
  }
  >.slide-down-enter-active {
    transition: all .3s ease;
  }
  >.slide-down-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  >.slide-down-enter, .slide-down-leave-to {
    transform: translateY(-30px);
    opacity: 0;
  }
  >.options {
    position: absolute;
    top: 57px;
    z-index: 4;
    background: white;
    width: 100%;
    border-radius: 0 0 5px 5px;
    transition: all ease .2s;
    max-height: 15rem;
    overflow: auto;
    box-shadow: lightgrey 0px 1px 3px 0px;
    >.option {
      padding: 25px 20px;
      font-size: 14px;
      font-weight: normal;
      color: $text-color;
      text-align: left;
      cursor: pointer;
      &:hover {
        background: $gray;
      }
    }
    .option + .option {
      border-top: 1px solid $border-color;
    }
  }
}
.c-select-container + .c-select-container {
  z-index: 2;
}
.c-select {
  padding: 20px;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .error-message {
    position: static;
  }
  .content {
    width: 100%;
    display: contents;
    .label{
      color: #121E48;
      font-size: 11px;
    }
  }
  .icon {
    &.-opened {
      transform: rotate(180deg);
    }
  }
  .dropdown-button {
    width: 85%;
    text-align: left;
    background-color: transparent;
    border: none;
    color: $text-color;
    font-size: 14px;
    cursor: pointer;
    padding-left: 6rem;
    position: absolute;
    -webkit-appearance: none !important;
  }
  .dropdown-button:focus {
    outline: none !important;
  }
}

.-error{
  box-shadow: red 0px 0px 5px 0px;
  & ::placeholder{
      color: red;
    }
}
.externalOverlay{

}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CSelectStyled.vue